import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = () => ({
  selectedStatus: { text: "Select", value: null },
  selectedDate: { text: "Select", value: null },

  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null,
  currentPage: 1,
});

const getters = {
  getSelectedStatus: (state) => state.selectedStatus,
  getSelectedDate: (state) => state.selectedDate,

  getStartDate: (state) => state.startDate,
  getEndDate: (state) => state.endDate,
  getStartTime: (state) => state.startTime,
  getEndTime: (state) => state.endTime,
 getCurrentPage: (state) => state.currentPage,
    isFilterApplied: (state) => {
    return (
      state.selectedStatus?.value !== null ||
      state.selectedDate?.value !== null ||
      state.startDate !== null ||
      state.endDate !== null ||
      state.startTime !== null ||
      state.endTime !== null
    );
  },
};

const mutations = {
  SET_FILTERS(state, payload) {
    Object.assign(state, payload);
  },

  RESET_FILTERS(state) {
    state.selectedStatus = { text: "Select", value: null };
    state.selectedDate = { text: "Select", value: null };
    state.startDate = null;
    state.endDate = null;
    state.startTime = null;
    state.endTime = null;
    state.searchQuery = "";
     state.currentPage = 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
